<template>
    <div style="min-height: 100vh; background-color: #0f172b">
        <PageContent :urlPath="urlPath" />
        <FooterBlockContent />
    </div>
</template>

<script>
import PageContent from '@/components/crane/builderio/PageContent.vue'
import FooterBlockContent from '../../components/crane/builderio/FooterBlockContent.vue'

export default {
    name: 'BuilderioPage',
    components: {
        PageContent,
        FooterBlockContent,
    },
    computed: {
        urlPath() {
            return this.$route.meta.builderioUrlPath || this.$route.path
        },
    },
    mounted() {
        document.documentElement.style.scrollBehavior = 'smooth'
        history.scrollRestoration = 'auto'
    },
    beforeUnmount() {
        document.documentElement.style.scrollBehavior = ''
        history.scrollRestoration = 'manual'
    },
}
</script>
